module.exports = __webpack_public_path__ + "static/media/qasim.91a5eaa4.jpeg";